module.exports = __webpack_public_path__ + "img/4_floor.0626e524.png";